import React, { FC } from 'react'
import styled, { css } from 'styled-components'
import { useDebouncedCallback } from 'use-debounce'

import { Box } from '@wirtualna-polska/n2cr-ds'

const VALIDATION_COLOR_PATTERN = /^#([a-fA-F0-9]){3}$|[a-fA-F0-9]{6}$/

interface FormInputColorProps {
  value: string
  onChange: (color: string) => void
}

const FormInputColor: FC<FormInputColorProps> = ({ value, onChange }) => {
  const color = VALIDATION_COLOR_PATTERN.test(value) ? value : `#${value}`

  const handleOnChangeDebounce = useDebouncedCallback(onChange, 300)

  return (
    <BoxStyled selectedColor={color}>
      <FormInputColorStyled
        data-testid="input-color"
        type="color"
        value={color}
        onChange={e => handleOnChangeDebounce(e.currentTarget.value)}
      />
    </BoxStyled>
  )
}

const FormInputColorStyled = styled.input`
  appearance: none;
  border: none;
  background: none;
  padding: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
`

const BoxStyled = styled(Box)<{ selectedColor?: string }>`
  ${p => css`
    width: 36px;
    cursor: pointer;
    border-radius: ${p.theme.radii.rounded};
    background-color: ${p.selectedColor};
    border: ${p.theme.borders.thinGrey20};
  `}
`

export default FormInputColor
